import SignInButton from '@/features/auth/components/sign-in-button';
import UserMenu from '@/features/auth/components/user-menu';
import { useAuth } from '@/hooks/use-auth';

const AuthConsoleControl = () => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <UserMenu /> : <SignInButton />;
};

export default AuthConsoleControl;
